// SPDX-License-Identifier: AGPL-3.0-or-later
// SPDX-FileCopyrightText: 2026 Dobrev IT Ltd

// WB-009 — deterministic per-author colors. The same user maps to the same color on
// every client with no coordination, so a mark's author is legible by color alone. Each
// client draws in ITS author color (the color rides on the stroke op), so peers render
// the right color without a directory.

// A palette of distinct hues that read well on the dark call/board background.
export const ANNOTATION_PALETTE = [
  "#ff5252", // red
  "#ffb300", // amber
  "#ffee58", // yellow
  "#66bb6a", // green
  "#26c6da", // cyan
  "#42a5f5", // blue
  "#7e57c2", // violet
  "#ec407a", // pink
] as const;

// A small, stable string hash (FNV-1a, 32-bit) — deterministic across clients/runs.
function hash(s: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}

/** The stable annotation color for a user id. */
export function userColor(userID: string): string {
  return ANNOTATION_PALETTE[hash(userID) % ANNOTATION_PALETTE.length];
}
